<div class="row">
    <span *ngFor="let swimmer of swimmers; let i = index">
        <app-avatar *ngIf="i < limit.min || (i < countPhoto && i < limit.max)"
                    [user]="swimmer.swimmerID._user" imgClass="ui avatar image">
        </app-avatar>
    </span>
    <span *ngIf="others > 0" translate="SHARED.SWIMMER-LIST.MORE"
          [translateParams]="{ value: others }"></span>
</div>